var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"text-center"},[_c('d-button',{staticClass:"btn btn-danger",on:{"click":function($event){return _vm.disconnect()}}},[_vm._v("Disconnect")])],1)}
var staticRenderFns = []

export { render, staticRenderFns }